/* analytics-events.jsx — Plausible custom event helpers
 *
 * Pre-wires the events documented in tasks/LAUNCH-CHECKLIST.md that don't
 * require auth or paywall infrastructure. Auth-gated events (signup,
 * paywall_hit, paywall_convert) wire up later in Epic E.
 *
 * Plausible script already loaded in <head> (pa-fg2ZCCaynhZzPfre-kHD7.js).
 * window.plausible(name, { props }) — safe to call; no-op if blocked.
 */

(function() {
  if (typeof window === "undefined") return;

  // -----------------------------------------------------------------
  // Helper: safe-call plausible (no-op if blocked / not loaded)
  // -----------------------------------------------------------------
  window.kzTrack = function(eventName, props) {
    try {
      if (typeof window.plausible === "function") {
        window.plausible(eventName, { props: props || {} });
      }
    } catch (e) {
      /* silently swallow — analytics never breaks UX */
    }
  };

  // -----------------------------------------------------------------
  // 1. Outbound link tracking
  // -----------------------------------------------------------------
  // Tags any <a> with href starting with http/https that isn't kevinz.ai.
  // Sends event { url, location } where location = path of current page.
  // -----------------------------------------------------------------
  const HOSTNAMES_INTERNAL = new Set(["kevinz.ai", "www.kevinz.ai", "localhost"]);

  function isOutbound(href) {
    try {
      const u = new URL(href, window.location.href);
      return /^https?:$/i.test(u.protocol) && !HOSTNAMES_INTERNAL.has(u.hostname);
    } catch (e) {
      return false;
    }
  }

  document.addEventListener("click", function(e) {
    const a = e.target.closest && e.target.closest("a[href]");
    if (!a) return;
    const href = a.getAttribute("href");
    if (!href || !isOutbound(href)) return;

    window.kzTrack("outbound", {
      url: href,
      location: window.location.pathname,
      // useful for affiliate audit (uses.html has ?ref=kevinz links)
      affiliate: /[?&]ref=kevinz\b/i.test(href) ? "kevinz" : null,
    });
  }, { capture: true, passive: true });

  // -----------------------------------------------------------------
  // 2. Scroll-depth tracking (25/50/75/100%)
  // -----------------------------------------------------------------
  // Fires at most once per threshold per page-load.
  // Only on /post/* and /posts pages where scroll depth is meaningful.
  // -----------------------------------------------------------------
  const SCROLL_PATHS = ["/post/", "/posts", "/about", "/uses"];

  const shouldTrackScroll = SCROLL_PATHS.some(function(p) {
    return window.location.pathname.startsWith(p);
  });

  if (shouldTrackScroll) {
    const fired = new Set();
    let ticking = false;

    function checkDepth() {
      ticking = false;
      const doc = document.documentElement;
      const scrolled = (doc.scrollTop + window.innerHeight) / doc.scrollHeight;
      const pct = Math.round(scrolled * 100);

      [25, 50, 75, 100].forEach(function(t) {
        if (pct >= t && !fired.has(t)) {
          fired.add(t);
          const slug = window.location.pathname.replace(/^\//, "").replace(/\/$/, "") || "home";
          window.kzTrack("scroll_depth", { slug: slug, depth: t });
        }
      });
    }

    window.addEventListener("scroll", function() {
      if (!ticking) {
        window.requestAnimationFrame(checkDepth);
        ticking = true;
      }
    }, { passive: true });

    // Initial check (in case content is short)
    setTimeout(checkDepth, 1000);
  }

  // -----------------------------------------------------------------
  // 3. Product / brand pill click tracking
  // -----------------------------------------------------------------
  // Tags clicks on /products/* and brand pills.
  // -----------------------------------------------------------------
  document.addEventListener("click", function(e) {
    const a = e.target.closest && e.target.closest("a[href]");
    if (!a) return;
    const href = a.getAttribute("href") || "";

    if (href.startsWith("/products/") || href.startsWith("/product/")) {
      const product = href.replace(/^\/products?\//, "").replace(/\/$/, "").split("/")[0];
      window.kzTrack("product_click", { product: product, location: window.location.pathname });
    }
  }, { capture: true, passive: true });
})();
